import { Component } from 'react';

import styles from './ComplionToolbar.scss';

class ComplionToolbarGroup extends Component {
    render() {
        const { children } = this.props;
        return (
            <div className={styles.complionToolbarGroup} data-cy="ComplionToolbarGroup">
                {children}
            </div>
        );
    }
}

export default ComplionToolbarGroup;